import angular from 'angular'

import templateUrl from './edit-role.component.html';
import { CreateClaimModal } from './create-claim-modal.component';

export const EditRoleComponent = {
    templateUrl,
    controller: class EditRoleController {
        constructor($uibModal, $state, utilityService, roleService) {
            'ngInject';
            this.utilityService = utilityService;
            this.$uibModal = $uibModal;
            this.$state = $state;
            this.roleService = roleService;
            this.editRoleValue = btoa('http://schemas.microsoft.com/ws/2008/06/identity/claims/role');
        }

        $onInit() {
            this.pristineRole = angular.copy(this.role);
            this.backUrl = "admin/roles";
            this.grantTypes = [
                { Value: "GrantAll", Text: "Grant All" },
                { Value: "GrantRole", Text: "Grant Role" },
                { Value: "GrantClaims", Text: "Grant Claims" },
                { Value: "None", Text: "None" }
            ]
            this.scopes = [
                { Value: "Global", Text: "Global" },
                { Value: "Divisional", Text: "Divisional" },
                { Value: "Organizational", Text: "Organizational" },
                { Value: "EmploymentRecord", Text: "Employment Record" },
                { Value: "Hidden", Text: "Hidden" }
            ]

        }

        $onChanges(changesObj) {
            if (changesObj.divisions || changesObj.role) {
                this.roleDivisions = this.role.Divisions ?
                    this.role.Divisions.map(divisionID => this.divisions.find(division => division.Id === divisionID)) :
                    [];
            }
        }

        handleSubmit() {
            if (this.editForm.$valid) {
                this.onSubmit();
            }

        }
        handleCancelClick() {
            this.role = angular.copy(this.pristineRole);
            this.editForm.$setPristine();
        }

        onSubmit() {
            this.errorMsg = null;
            let saveRole;
            this.utilityService.showLoading();
            const request = {
                Name: this.role.Name,
                Description: this.role.Description,
                GrantType: this.role.GrantType,
                Scope: this.role.Scope,
                MinPositionsFilled: this.role.MinPositionsFilled,
                MaxPositionsFilled: this.role.MaxPositionsFilled,
                Divisions: this.role.Scope === "Divisional" ? this.roleDivisions.map(division => division.Id) : null,
                Claims: this.role.Claims ? this.role.Claims : null
            };
            if (this.role.RoleID) {
                saveRole = this.roleService.updateRoleV2(this.role.RoleID, request);
            } else {
                saveRole = this.roleService.createRoleV2(request);
            }

            saveRole
                .then(() => {
                    this.editForm.$setPristine();
                    this.$state.reload();
                })
                .catch((ex) => {
                    this.errorMsg = this.utilityService.getExceptionMessage(ex);
                    console.error(ex);
                    if (ex.data) {
                        this.modelState = ex.data.ModelState;
                    } else {
                        alert(this.utilityService.getExceptionMessage(ex));
                    }
                })
                .then(() => {
                    this.utilityService.hideLoading();
                })
        }

        onDelete(claim) {
            const index = this.role.Claims.indexOf(claim);
            if (index > -1) {
                this.role.Claims.splice(index, 1);
                this.editForm.$setDirty();
            }
        }

        onEditClaims(claim) {
            if (claim.Type) {
                this.$state.go("admin.claim.edit", {
                    claimType: btoa(claim.Type),
                    claimValue: claim.Value || ""
                });
            }
        }

        onAddClaim() {
            this._showCreateClaimModal();
        }

        _showCreateClaimModal() {
            this.$uibModal.open({
                ...CreateClaimModal,
                resolve: {
                    role: () => this.role
                }

            }).result
                .then(() => {
                    this.editForm.$setDirty();
                })
                .catch(ex => {
                    if (ex && (ex === "cancel" || ex.$value === "cancel")) {
                        return;
                    }
                    console.error(ex);
                })
        }
    },
    controllerAs: "vm",
    require: {
        editForm: "?^^form"
    },
    bindings: {
        role: "<",
        divisions: "<"
    }
}
